import React from 'react'
import '../Stylesheet/Prenavbar.css'

function Prenavbar() {
  return (
    <div className="prenav">
    <div>
        <a href="https://www.mi.store.com/in/">MI INDIA</a><span>|</span>
        <a href="https://www.mi.store.com/in/">GET MI STORE APP</a><span>|</span>
        <a href="https://www.mi.store.com/in/">ONLINE HELP</a><span>|</span>
        <a href="https://www.mi.store.com/in/">RETAIL STORE</a>
    </div>
    <div>
    
        <a href="https://www.mi.store.com/in/">SIGN IN</a><span>|</span>
        <a href="https://www.mi.store.com/in/">SIGN UP</a><span>|</span>
        <a href="https://www.mi.store.com/in/">CART (0)</a>

    </div>
    </div>
  )
}

export default Prenavbar